import { connect } from "react-redux";

import QuickAccess from "./QuickAccess.component";

function mapStateToProps() {
  return {};
}

function mapDispatchToProps() {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(QuickAccess);
